<template>
  <div class="richtext-container">
    <div class="richtext-wrapper" :style="{'max-height': overflowHeight && !isExpand ? overflowHeight + 'px': 'none'}">
      <div class="richtext-content" ref="richtext"  v-html="richtext"></div>
    </div>
    <div class="toggle-wrapper" v-if="overflowHeight">
      <span @click="toggle" v-if="!isExpand && height > overflowHeight">展开<i class="iconfont icon-down1"></i></span>
      <span @click="toggle" v-if="isExpand && height > overflowHeight">收起<i class="iconfont icon-up"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RichtextComponent',
  props: {
    content: String,
    overflowHeight: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      height: 0,
      isExpand: false
    }
  },
  computed: {
    richtext () {
      if (this.content === undefined || this.content === null) {
        return ''
      }
      return this.content.replace(/&nbsp;/g, ' ')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.height = this.$refs.richtext.clientHeight
      console.log(this.height)
    })
    //console.log('richtext--',this.$refs.richtext.getElementsByTagName('img'))
    // console.log(this.$refs.richtext.getElementsByTagName('img'))
    // this.$refs.richtext.getElementsByTagName('img').forEach(item => {
    //   item.addEventListener('click', () => {
    //      self.$viewImage({
    //     zIndex: 1, // 图片预览的z-index值 一般情况下不需要传
    //     initialIndex: 0, // 初始化展示图片的序号 默认为0
    //     imgList: [{url:item.src,name:""}], //图片列表 name可选 url必选
    //   });
    //   })
    // })
  },
  methods: {
    // initMathJax () {
    //   this.$nextTick(() => {
    //     try {
    //       MathJax.Hub.Queue(["Typeset", MathJax.Hub, ""]);
    //       console.log('mathjax')
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   })
    // }
    toggle () {
      this.isExpand = !this.isExpand
    }
  },
  watch: {
    content: {
      handler () {
        // this.initMathJax()
        this.$nextTick(() => {
          this.height = this.$refs.richtext.clientHeight
          console.log(this.height)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.richtext-container{
  .richtext-wrapper{
    overflow: hidden;
  }
  .richtext-content{
    line-height: 1.5;
    font-size: 14px;
    word-break: break-word;
    overflow: hidden;
    ::v-deep{
      img{
        max-width: 100%;
      }
      p{
        margin: 0 0 8px 0;
      }
      svg{
        max-width: 100%;
      }
    }
  }
  .toggle-wrapper{
    text-align: center;
    span{
      cursor: pointer;
      i{
        margin-left: 6px;
        font-size: 12px;
      }
      &:hover{
        color: $--color-primary;
      }
    }
  }
}

</style>